import {
    getDeliveryArticlesByCategoryAndTag,
    GetDeliveryArticlesByCategoryAndTagApiResponseSchema,
    loadMoreDeliveryArticlesByCategoryAndTag,
} from './get-delivery-articles-by-category-and-tag';
import {
    getDeliveryArticleCategories,
    GetDeliveryArticleCategoriesApiResponseSchema,
} from './get-delivery-article-categories';
import {
    getDeliveryArticleTags,
    GetDeliveryArticleTagsApiResponseSchema,
} from './get-delivery-article-tags';
import {
    getDeliveryService,
    GetDeliveryServiceActionResponseMapper,
} from './get-delivery-service';

export {
    GetDeliveryArticlesByCategoryAndTagApiResponseSchema,
    GetDeliveryArticleCategoriesApiResponseSchema,
    GetDeliveryArticleTagsApiResponseSchema,
    GetDeliveryServiceActionResponseMapper,
};

export const DeliveryPageActions = {
    getDeliveryArticlesByCategoryAndTag,
    getDeliveryArticleCategories,
    getDeliveryArticleTags,
    getDeliveryService,
    loadMoreDeliveryArticlesByCategoryAndTag,
};
